import type { OrderFrequency, PackagingPreference } from "@jti/fe-common";

import { useSticksDataContext } from "@product-details/providers";

type SetAggregationPayload = {
  orderFrequency: OrderFrequency;
  packagingPreference: PackagingPreference;
  shouldUseFallback?: boolean;
  onSuccess?: () => void;
  predefinedSku?: string;
};

export type SetAggregationType = (payload: SetAggregationPayload) => boolean;

export const useSetAggregation = () => {
  const { currentProduct, setCurrentSKU, fallbackProductsSkus } = useSticksDataContext();

  const setAggregation = ({
    orderFrequency,
    packagingPreference,
    shouldUseFallback,
    onSuccess,
    predefinedSku,
  }: SetAggregationPayload) => {
    if (predefinedSku) {
      onSuccess?.();
      setCurrentSKU(predefinedSku);
      return true;
    }
    const relatedProductSku = shouldUseFallback
      ? fallbackProductsSkus?.[orderFrequency][packagingPreference]
      : currentProduct.aggregations?.[orderFrequency][packagingPreference]?.sku;

    if (!relatedProductSku) {
      return false;
    }

    onSuccess?.();
    setCurrentSKU(relatedProductSku);
    return true;
  };

  return { setAggregation };
};
